<template>
  <d-container
    fluid
    class="main-content-container route-templates px-4">
    <d-row
      no-gutters
      class="page-header pt-4 mb-3">
      <d-col
        col
        sm="12"
        class="text-center text-sm-left mb-0 mb-sm-0">
        <span class="text-uppercase page-subtitle">Szablony tras</span>
        <h3 class="page-title">Harmonogram tygodniowy</h3>
      </d-col>
    </d-row>

    <div class="mt-4 mb-3">
      <d-tabs>
        <d-tab
          v-for="(day, index) in daysMap"
          :key="day.value"
          :title="day.label"
          :active="selectedDayIndex === index"
          @click="selectedDayIndex = index">
        </d-tab>
      </d-tabs>
    </div>

    <d-card
      style="width: 100%;"
      class="mb-3">
      <route-templates-transport
        :show-component="true"
        :day="currentDay.value" />
    </d-card>
  </d-container>
</template>

<script>
import RouteTemplatesTransport from './RouteTemplatesTransport.vue';

export default {
  name: 'route-templates',
  components: {
    RouteTemplatesTransport
  },
  data () {
    return {
      daysMap: [
        { value: 'monday', label: 'Poniedziałek' },
        { value: 'tuesday', label: 'Wtorek' },
        { value: 'wednesday', label: 'Środa' },
        { value: 'thursday', label: 'Czwartek' },
        { value: 'friday', label: 'Piątek' },
        { value: 'saturday', label: 'Sobota' },
        { value: 'sunday', label: 'Niedziela' }
      ],
      selectedDayIndex: 0,
      todayIndex: 0
    };
  },
  computed: {
    currentDay () {
      return this.daysMap[this.selectedDayIndex];
    }
  },
  created () {
    this.initCurrentDay();
  },
  methods: {
    initCurrentDay () {
      const jsDay = new Date().getDay();
      const mappedDay = (jsDay + 6) % 7;

      this.todayIndex = mappedDay;
      this.selectedDayIndex = mappedDay;
    }
  }
};
</script>

<style lang="scss">
.route-templates .order__date_top_text .text {
  width: 150px;
}
</style>
